// src/components/CookieConsent.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 👈 NOVO IMPORT
import '../styles/CookieConsent.css';

const CookieConsent = () => {
  const { t } = useTranslation(); // 👈 NOVO HOOK
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem('cookie_consent');
    if (!consentGiven) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    setShowConsent(false);
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className='cookie-consent-overlay'>
      <div className='cookie-consent-container'>
        <div className='cookie-consent-box'>
          <h4>{t('cookie_title')}</h4>
          <p>
            {t('cookie_message_text', {
              link: <Link to='/terms'>{t('cookie_terms_link')}</Link>,
            })}
          </p>
          <button onClick={handleAccept}>{t('cookie_accept_button')}</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
